module.exports = __webpack_public_path__ + "assets/img/carousel-3-320.9577efad.webp";